import CustomButton from '../../../common/components/CustomButton';
import DateTimeUtility from '../../../common/utility/DateTimeUtility';

function KaraokeListItemView({
  karaokeOrder,
} : {
  karaokeOrder: {
    id: number,
    delivery_status: number,
    title: string,
    delivery_completed_date: string,
  },
}) {
  let className;
  let statusText;
  switch (karaokeOrder.delivery_status) {
    case 1:
      className = 'payment';
      statusText = '入金待ち';
      break;
    case 2:
      className = 'data_delivery';
      statusText = 'データ納品待ち';
      break;
    case 3:
      className = 'production';
      statusText = '制作中';
      break;
    case 4:
    {
      className = 'delivery';
      const deliveryCompletedDate = DateTimeUtility.toDate(karaokeOrder.delivery_completed_date);
      if (deliveryCompletedDate !== null && deliveryCompletedDate < new Date()) {
        statusText = '配信中';
      } else {
        statusText = '配信待ち';
      }
      break;
    }
    default:
      className = '';
      statusText = '';
  }
  return (
    <dl>
      <dd>
        <a href={`/karaoke_modification/view/${karaokeOrder.id}`}>
          <div className="status_wrap">
            <span className={`status ${className}`}>{statusText}</span>
          </div>
          <span className="title">{karaokeOrder.title}</span>
          <div className="arrow" />
        </a>
      </dd>
    </dl>

  );
}

export default function KaraokeListView({
  karaokeOrders,
} : {
  karaokeOrders: {
    id: number,
    delivery_status: number,
    title: string,
    delivery_completed_date: string,
  }[],
}) {
  const onDistribute = () => {
    window.location.href = '/karaoke_orders#c-form';
  };
  return (
    <>
      <h2>配信曲一覧</h2>
      <form className="music_list">
        <div className="form__data form__body list">
          <ul>
            <li className="bt">
              <CustomButton type="default" onClick={() => onDistribute()}>配信する（新規作成）</CustomButton>
            </li>
          </ul>
          {karaokeOrders.map((karaokeOrder) => (
            <KaraokeListItemView key={karaokeOrder.id} karaokeOrder={karaokeOrder} />
          ))}
        </div>
      </form>
    </>
  );
}
